"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCountryOptions = void 0;
var _config = require("../i18n/config");
var getCountryOptions = function getCountryOptions() {
  var countryCodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _config.FALLBACK_LOCALE;
  var localeCode = locale.split('-')[0];
  var countryName = new Intl.DisplayNames([localeCode], {
    type: 'region'
  });
  return countryCodes.map(function (countryCode) {
    return {
      label: countryName.of(countryCode),
      value: countryCode
    };
  });
};
exports.getCountryOptions = getCountryOptions;